import React, { useState, useEffect, Suspense } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Aos from "aos";
import "aos/dist/aos.css";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Preloader from "./components/Preloader";
import ScrollToTop from "./components/ScrollToTop";
import ScrollToTopButton from "./components/ScrollToTopButton";
import WhatsAppButton from "./components/WhatsAppButton";

import Home from "./components/Home/Home";
import Sobremi from "./components/pages/Sobremi";
import AerialPhotography from "./components/pages/AerialPhotography";
import RealEstate from "./components/pages/RealEstate";
import Events from "./components/pages/Events";
import Services from "./components/pages/Services";
import FPV from "./components/pages/FPV";
import Policy from "./components/Policy";
import Conditions from "./components/Conditions";
import LegalNotice from "./components/AvisoLegal";
import Cookies from "./components/Cookies";
import Works from "./components/pages/Works";
import WorkDetail from "./components/pages/WorkDetail";
import Drones from "./components/pages/Drones";
import NotFound from "./components/pages/NotFound";
import Links from "./components/BioLinks/BioLinks";
import Academia from "./components/Academia/Academia";

import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./i18n"; // i18next
import CookieConsent from "react-cookie-consent";

function App() {
   const [load, updateLoad] = useState(true);
const [cookieExists, setCookieExists] = useState(false);

   useEffect(() => {
      const cookie = document.cookie
         .split("; ")
         .find((row) => row.startsWith("userCookieConsent="));

      if (cookie) {
         setCookieExists(true);
      }
      const timer = setTimeout(() => updateLoad(false), 1100);
      Aos.init();
      return () => clearTimeout(timer);
   }, []);

   const handleAcceptCookies = () => {
      setCookieExists(true);
   };

   const handleDeclineCookies = () => {
      setCookieExists(true);
   };

   return (
      <Router basename="/">
         <div className="App" id={load ? "no-scroll" : "scroll"}>
            <Suspense fallback={<div>Loading...</div>}>
               <Switch>
                  {/* RUTA SIN NAVBAR NI FOOTER */}
                  <Route path="/links" exact component={Links} />
                  <Route
                     path="/aprender-fpv"
                     exact
                     render={() => <Academia cookiesAccepted={cookieExists} />}
                  />

                  {/* TODAS LAS DEMÁS */}
                  <Route
                     path="/:lang(en)?"
                     render={({ match }) => (
                        <>
                           <Navbar />
                           <ScrollToTop />
                           <Switch>
                              <Route
                                 path={`${match.path}/`}
                                 exact
                                 render={() => (
                                    <Home cookiesAccepted={cookieExists} />
                                 )}
                              />
                              <Route
                                 path={`${match.path}/trabajos/:videoName`}
                                 component={WorkDetail}
                              />
                              <Route
                                 path={`${match.path}/trabajos`}
                                 component={Works}
                              />
                              <Route
                                 path={`${match.path}/drones`}
                                 component={Drones}
                              />
                              <Route
                                 path={`${match.path}/politica-privacidad`}
                                 component={Policy}
                              />
                              <Route
                                 path={`${match.path}/condiciones`}
                                 component={Conditions}
                              />
                              <Route
                                 path={`${match.path}/aviso-legal`}
                                 component={LegalNotice}
                              />
                              <Route
                                 path={`${match.path}/cookies`}
                                 component={Cookies}
                              />
                              <Route
                                 path={`${match.path}/fotografia-aerea`}
                                 component={AerialPhotography}
                              />
                              <Route
                                 path={`${match.path}/drones-inmobiliaria`}
                                 component={RealEstate}
                              />
                              <Route
                                 path={`${match.path}/grabacion-eventos-dron`}
                                 component={Events}
                              />
                              <Route
                                 path={`${match.path}/servicios-drones`}
                                 component={Services}
                              />
                              <Route
                                 path={`${match.path}/sobre-mi`}
                                 component={Sobremi}
                              />
                              <Route
                                 path={`${match.path}/grabacion-fpv`}
                                 component={FPV}
                              />
                              <Route component={NotFound} />
                           </Switch>
                           <Footer />
                           <WhatsAppButton />
                           <ScrollToTopButton />
                        </>
                     )}
                  />
               </Switch>
            </Suspense>
            {/* <Preloader load={load} /> */}
            {/* Banner de cookies */}
            <CookieConsent
               location="bottom"
               buttonText="Aceptar"
               declineButtonText="Rechazar"
               enableDeclineButton
               cookieName="userCookieConsent"
               onAccept={handleAcceptCookies}
               onDecline={handleDeclineCookies}
               expires={15}
               style={{
                  background: "var(--imp-background-color)",
                  color: "var(--imp-background-light-color)",
                  fontSize: "14px",
                  padding: "16px 24px",
                  textAlign: "center",
               }}
               buttonStyle={{
                  background: "var(--imp-text-color)",
                  color: "var(--imp-background-color)",
                  fontWeight: "bold",
                  fontSize: "14px",
                  borderRadius: "8px",
                  padding: "8px 16px",
                  margin: "0 8px",
                  cursor: "pointer",
               }}
               declineButtonStyle={{
                  background: "transparent",
                  color: "var(--imp-background-light-color)",
                  fontWeight: "bold",
                  fontSize: "14px",
                  borderRadius: "8px",
                  padding: "8px 16px",
                  margin: "0 8px",
                  border: "1px solid var(--imp-background-light-color)",
                  cursor: "pointer",
               }}
               buttonWrapperClasses="cookie-buttons-wrapper"
            >
               Esta web utiliza cookies de terceros (Vimeo, Google) para mejorar
               la experiencia de usuario. Para más información sobre el uso de
               cookies, consulta la{" "}
               <a
                  href="/cookies"
                  style={{
                     color: "var(--imp-text-color)",
                     textDecoration: "underline",
                  }}
               >
                  Política de Cookies
               </a>
               .
            </CookieConsent>
         </div>
      </Router>
   );
}

export default App;
